import type { FC } from "react";
import { ArrowUpSmall } from "@wix/wix-ui-icons-common";

export const RotatedArrow: FC<{ degrees?: number }> = ({ degrees = 45 }) => (
  <ArrowUpSmall style={{ transform: `rotate(${degrees}deg)` }} size={24} />
);
